import React, { useEffect, useRef, useState } from 'react';
import './HeroSection.css';
import { useNavigate } from "react-router-dom";
import { Button } from '@mui/material'

const labels = {
  si: {
    heading: 'ඔබගේ මනාලයන් සහ මනාලියන් මෙහි සොයා ගන්න...',
    sub: 'ඔබ බලා සිටින්නේ කුමක් සඳහාද?',
    ctaPrimary: 'අරඹන්න',
    ctaSecondary: 'ඔබ සඳහා වඩාත් සුදුසු කාලය සොයන්න',
  },
  en: {
    heading: 'Find your bride and groom here...',
    sub: 'What are you looking for?',
    ctaPrimary: 'Get started',
    ctaSecondary: 'Find the best time for you',
  }
};

const HeroSection = () => {
  const navigate = useNavigate();
  const [lang, setLang] = React.useState(() => localStorage.getItem('language') || 'si');
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef(null);

  React.useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'language' && e.newValue) setLang(e.newValue);
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);

  const t = labels[lang] ?? labels.si;
   const handleGetStarted = () => {
    const token = localStorage.getItem('userToken');  // or 'user', etc.
    if (token) {
      navigate('/profile');       // user logged in -> go to profile
    } else {
      navigate('/login');        // not logged in -> go to signup
    }
  };

  return (
    <div className='hero-container' ref={heroRef}>
      <video src='../../images/weddingV.mp4' autoPlay muted loop playsInline preload="metadata" />
      <h2 className={isVisible ? 'hero-text-popup' : ''}>{t.heading}</h2>
      <p className={isVisible ? 'hero-text-popup' : ''}>{t.sub}</p>
      <div className={`hero-btns ${isVisible ? 'hero-btns-popup' : ''}`}>
        <Button variant='contained' color='primary' size='large' onClick={handleGetStarted}>
          {t.ctaPrimary}
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          size="large"
          onClick={() => navigate('/day-finder')}
          sx={{
            ml: 2,
            color: '#D4AF37', // Gold
            borderColor: '#D4AF37',
            borderWidth: 1.5,
            borderRadius: 1, // Sharp/Slightly rounded
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(212, 175, 55, 0.1)',
              borderColor: '#D4AF37',
              borderWidth: 1.5,
            },
          }}
        >
          {t.ctaSecondary}
        </Button>
      </div>
    </div>
  );
}

export default HeroSection;